const FR = {
  "immobilier.nav.label": "Immobilier & Séjours",
  "immobilier.hero.kicker": "Marketplace · Immobilier & Séjours",
  "immobilier.hero.title": "IMMOBILIER & SÉJOURS",
  "immobilier.hero.subtitle": "Habiter, investir, séjourner — autrement, ensemble.",
  "immobilier.hero.publish": "Publier un bien",
  "immobilier.demo.badge": "DÉMONSTRATION",
  "immobilier.demo.notice": "Aperçu local sans annonce, disponibilité, réservation ni paiement réel.",
  "immobilier.tabs.label": "Parcours Immobilier & Séjours",
  "immobilier.tab.acheter": "Acheter",
  "immobilier.tab.louer": "Louer",
  "immobilier.tab.sejours": "Séjourner",
  "immobilier.tab.colocation": "Colocation",
  "immobilier.search.title": "Rechercher un bien",
  "immobilier.search.zone": "Destination ou zone",
  "immobilier.search.zone_placeholder": "Cannes",
  "immobilier.search.type": "Type de bien",
  "immobilier.search.type.all": "Tous les logements",
  "immobilier.search.type.apartment": "Appartement",
  "immobilier.search.type.villa": "Villa ou maison",
  "immobilier.search.type.room": "Chambre",
  "immobilier.search.arrival": "Arrivée",
  "immobilier.search.departure": "Départ",
  "immobilier.search.dates": "Dates",
  "immobilier.search.travellers": "Voyageurs",
  "immobilier.search.entry_date": "Date d’entrée",
  "immobilier.search.furnished": "Meublé",
  "immobilier.search.room_type": "Type de chambre",
  "immobilier.search.budget_min": "Budget minimum",
  "immobilier.search.budget_max": "Budget maximum",
  "immobilier.search.bedrooms": "Chambres minimum",
  "immobilier.search.explore": "Explorer",
  "immobilier.search.loading": "Recherche en cours…",
  "immobilier.search.errors_title": "Certaines informations sont à corriger",
  "immobilier.error.zone_required": "Indiquez une destination ou une zone.",
  "immobilier.error.date_invalid": "Choisissez une date valide.",
  "immobilier.error.departure_after": "Le départ doit être postérieur à l’arrivée.",
  "immobilier.error.travellers": "Choisissez entre 1 et 12 voyageurs.",
  "immobilier.error.budget": "Vérifiez la fourchette de budget.",
  "immobilier.entry.buy.title": "Acheter ou vendre",
  "immobilier.entry.buy.text": "Explorez un parcours immobilier clair, sans transaction en pré-lancement.",
  "immobilier.entry.rent.title": "Location longue durée",
  "immobilier.entry.rent.text": "Recherchez un logement ou préparez une future proposition locative.",
  "immobilier.entry.stay.title": "Séjours Eternua",
  "immobilier.entry.stay.text": "Découvrez des aperçus de séjours reliés au même bien central.",
  "immobilier.entry.roommate.title": "Colocation",
  "immobilier.entry.roommate.text": "Recherchez une chambre ou un logement partagé avec des critères neutres.",
  "immobilier.results.stays": "Séjours à découvrir",
  "immobilier.results.title": "Résultats de démonstration",
  "immobilier.results.count": "aperçus locaux",
  "immobilier.results.empty_title": "Aucun aperçu ne correspond à cette recherche",
  "immobilier.results.empty_text": "Modifiez la zone, le type de bien ou le nombre de voyageurs.",
  "immobilier.results.reset": "Réinitialiser la recherche",
  "immobilier.card.price_unknown": "Tarif à confirmer",
  "immobilier.card.capacity": "capacité",
  "immobilier.card.open": "Ouvrir la fiche",
  "immobilier.favorite.add": "Ajouter aux favoris",
  "immobilier.favorite.remove": "Retirer des favoris",
  "immobilier.favorite.local_notice": "Favoris conservés uniquement dans ce navigateur de développement.",
  "immobilier.summary.title": "Mon séjour",
  "immobilier.summary.no_selection": "Aucun logement sélectionné",
  "immobilier.summary.favorites": "Voir mes favoris",
  "immobilier.summary.agenda": "Ajouter à mon agenda",
  "immobilier.summary.agenda_unavailable": "La source Agenda Immobilier sera reliée dans une phase ultérieure.",
  "immobilier.summary.voyage_sync": "Synchronisé avec Voyage",
  "immobilier.summary.search_only": "Cette recherche n’est ni une demande ni une réservation.",
  "immobilier.state.offline_title": "Vous êtes hors connexion",
  "immobilier.state.offline_text": "Les aperçus déjà chargés restent consultables. Aucune action distante n’est tentée.",
  "immobilier.state.error_title": "L’aperçu n’a pas pu être chargé",
  "immobilier.state.error_text": "Réessayez ou revenez à la recherche de démonstration.",
  "immobilier.state.unavailable_title": "Fonctionnalité indisponible",
  "immobilier.state.unavailable_text": "Cette capacité reste fermée pendant le pré-lancement.",
  "immobilier.state.session_title": "Votre session est nécessaire",
  "immobilier.state.session_text": "Connectez-vous pour retrouver ce parcours sans perdre son contexte.",
  "immobilier.state.login": "Se connecter",
  "immobilier.detail.back": "Retour aux résultats",
  "immobilier.detail.features": "Caractéristiques",
  "immobilier.detail.amenities": "Équipements de démonstration",
  "immobilier.detail.accessibility": "Accessibilité",
  "immobilier.detail.contact": "Demander des informations",
  "immobilier.detail.contact_unavailable": "Les demandes de contact seront reliées au serveur en phase 2.",
  "immobilier.detail.no_payment": "Aucun paiement, acompte ou confirmation n’est disponible.",
  "immobilier.publish.title": "Publier un séjour",
  "immobilier.publish.subtitle": "Annonce persistante enregistrée sur Eternua",
  "immobilier.publish.mode": "Parcours",
  "immobilier.publish.property_title": "Titre de l’annonce",
  "immobilier.publish.public_zone": "Zone publique approximative",
  "immobilier.publish.description": "Description",
  "immobilier.publish.save": "Publier le séjour",
  "immobilier.publish.saved": "Séjour publié sur Eternua.",
  "immobilier.publish.moderation": "Soumettre à modération",
  "immobilier.publish.moderation_unavailable": "La soumission serveur est désactivée en phase 1.",
  "immobilier.publish.private_warning": "Ne saisissez aucune adresse exacte, pièce d’identité ou donnée financière.",
  "immobilier.favorites.title": "Mes favoris de démonstration",
  "immobilier.favorites.empty_title": "Aucun favori local",
  "immobilier.favorites.empty_text": "Ajoutez un aperçu depuis la page Immobilier & Séjours.",
  "immobilier.favorites.back": "Retour à Immobilier & Séjours",
  "immobilier.demo.villa.title": "Villa des Pins — aperçu local",
  "immobilier.demo.villa.description": "Une villa contemporaine ouverte sur la Méditerranée, présentée uniquement pour tester l’interface locale.",
  "immobilier.demo.villa.image_alt": "Villa méditerranéenne de démonstration avec piscine et vue mer",
  "immobilier.demo.apartment.title": "Appartement Horizon — aperçu local",
  "immobilier.demo.apartment.description": "Un appartement lumineux et traversant utilisé pour éprouver les parcours Louer et Séjourner.",
  "immobilier.demo.apartment.image_alt": "Séjour lumineux de démonstration avec balcon et vue sur la mer",
  "immobilier.demo.suite.title": "Suite du Suquet — aperçu local",
  "immobilier.demo.suite.description": "Une chambre chaleureuse servant à tester une offre de séjour et une recherche de colocation sans transaction.",
  "immobilier.demo.suite.image_alt": "Chambre méditerranéenne de démonstration ouvrant sur une terrasse",
};

const EN = {
  "immobilier.nav.label": "Real estate & Stays",
  "immobilier.hero.kicker": "Marketplace · Real estate & Stays",
  "immobilier.hero.title": "REAL ESTATE & STAYS",
  "immobilier.hero.subtitle": "Live, invest and stay — differently, together.",
  "immobilier.hero.publish": "List a property",
  "immobilier.demo.badge": "DEMONSTRATION",
  "immobilier.demo.notice": "Local preview with no real listing, availability, booking or payment.",
  "immobilier.tab.acheter": "Buy",
  "immobilier.tab.louer": "Rent",
  "immobilier.tab.sejours": "Stay",
  "immobilier.tab.colocation": "Roommates",
  "immobilier.search.explore": "Explore",
  "immobilier.card.price_unknown": "Price to be confirmed",
  "immobilier.summary.title": "My stay",
  "immobilier.summary.no_selection": "No property selected",
  "immobilier.summary.favorites": "View my favorites",
  "immobilier.summary.agenda": "Add to my calendar",
  "immobilier.results.stays": "Stays to discover",
  "immobilier.results.title": "Demonstration results",
};

export const IMMOBILIER_TRANSLATIONS = Object.freeze({
  fr: Object.freeze(FR),
  en: Object.freeze(EN),
  es: Object.freeze({}),
  it: Object.freeze({}),
  de: Object.freeze({}),
  et: Object.freeze({}),
});
